import getSelectedTableView from './getSelectedTableView';

/**
 * Utility function to tell whether the list pane is in checked mode or not
 */
export default function getIsInCheckedMode(): boolean {
    const tableView = getSelectedTableView();
    return !!tableView && tableView.isInCheckedMode;
}
